import React, { Children, cloneElement, ReactElement, useState } from 'react';

import TabsContainer from './styled/TabsContainer';
import TabsShadowSpaceFix from './styled/TabsShadowSpaceFix';
import { TabsProps, TabsState } from './types';

const Tabs: React.FC<TabsProps> = props => {
  const [state, setState] = useState<TabsState>({
    activeTabIndex:
      props.initialActiveTabIndex &&
      Array.isArray(props.children) &&
      props.initialActiveTabIndex < props.children.length
        ? props.initialActiveTabIndex
        : 0,
  });
  const handleTabClick = (tabIndex: number) => () =>
    setState({ activeTabIndex: tabIndex });

  const renderTabsWithApiAsProps = (): JSX.Element[] =>
    Children.map<ReactElement, ReactElement>(props.children, (tab, index) =>
      cloneElement(tab, {
        onClick: handleTabClick,
        tabIndex: index,
        active: index === state.activeTabIndex,
      }),
    );

  const renderActiveTabContent = (): JSX.Element | null => {
    if (!Array.isArray(props.children)) return null;
    const activeTab = props.children[state.activeTabIndex] as ReactElement;

    if (activeTab) {
      if (activeTab.props.children.length > 1) {
        return activeTab.props.children[1];
      }

      return activeTab.props.children[0];
    }

    return null;
  };

  return (
    <div>
      <TabsShadowSpaceFix>
        <TabsContainer>{renderTabsWithApiAsProps()}</TabsContainer>
      </TabsShadowSpaceFix>
      {renderActiveTabContent()}
    </div>
  );
};

export default Tabs;
